export const validateValue = (value?: string | null, startValue?: string) => {
    return startValue ? (value?.startsWith(startValue) ? value : startValue) : value || '';
};
